// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"80ba193b","82":"80ba193b","158":"80ba193b","200":"80ba193b","334":"80ba193b","533":"90dae3f9","563":"80ba193b","575":"80ba193b","839":"6881c8de"}[chunkId] + ".chunk.css";
};